import styled from 'styled-components'

export default styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors.grey};
  padding-bottom: 10px;
`
